"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const translation_1 = require("../../../common/js/helper/translation");
const DataLayerEvents_1 = __importDefault(require("../../enums/DataLayerEvents"));
const dataLayer_1 = require("../../helper/dataLayer");
const NewsTeaserTile = ({ image, shortText, title, url }) => {
    return (react_1.default.createElement("div", { className: "col-12 col-sm-6 col-md-4 col-xl-3", onClick: () => {
            (0, dataLayer_1.pushToDataLayer)({
                event: DataLayerEvents_1.default.dlvDashboardNewsClick,
                value: title ?? '',
            });
        } },
        react_1.default.createElement("div", { className: "znd-dashboard-news-item h-100" },
            react_1.default.createElement("div", { className: "row h-100" },
                react_1.default.createElement("div", { className: "znd-dashboard-news-item__body col-8" },
                    react_1.default.createElement("div", { className: "d-flex h-100 flex-column justify-content-between" },
                        react_1.default.createElement("div", null,
                            title && title.length > 0 && (react_1.default.createElement("div", { className: "znd-dashboard-news-item__title t-subhead-2" }, title)),
                            react_1.default.createElement("div", { className: "znd-dashboard-news-item__text t-body-small" }, shortText)),
                        react_1.default.createElement("div", { className: "znd-dashboard-news-item__link t-body-small" },
                            react_1.default.createElement("a", { target: "news", href: url }, (0, translation_1.t)('dashboard.news.more'))))),
                image && image.length > 0 && (react_1.default.createElement("div", { className: "znd-dashboard-news-item__image col-4 pl-0" },
                    react_1.default.createElement("img", { src: image })))))));
};
exports.default = NewsTeaserTile;
